import { render } from "./gskd.vue?vue&type=template&id=1e86d997&scoped=true&ts=true"
import script from "./gskd.vue?vue&type=script&lang=ts"
export * from "./gskd.vue?vue&type=script&lang=ts"

import "./gskd.vue?vue&type=style&index=0&id=1e86d997&lang=less&scoped=true"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e86d997"]])

export default __exports__